export default __webpack_public_path__ + "static/media/learn-more-card-4.d5836a48.svg";